module.exports = __webpack_public_path__ + "static/media/loading.4bf74b33.gif";